import { createStyles } from 'antd-style'

export const useStyles = createStyles(({ token }) => ({
  card: {
    backgroundColor: `${token.primary.primary3}1a`
  },
  commentCardWrapper: {
    '& .ant-card-body': {
      padding: 0
    }
  },
  commentCard: {
    padding: '16px 24px'
  },
  commentDivider: {
    margin: 0
  },
  commentBeneficiary: {
    padding: '16px 10px',
    borderRadius: 6,
    backgroundColor: token.colorFillSecondary
  }
}))
